export default __webpack_public_path__ + "static/media/prix_de_la_vocation.07884739.mp4";